import React from 'react'

import {
  CAvatar,
  CDropdownItem,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarToggler,
} from '@coreui/react'

import { AppSidebarNav } from './AppSidebarNav'

import brandFull from 'src/assets/brand/brand-full.svg'
import brandNarrow from 'src/assets/brand/brand-narrow.svg'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'

// sidebar nav config
import navigation from '../_nav'
import {
  selectSidebarUnfoldable,
  setValue as updateSidebarUnfoldable,
} from '../redux/features/sidebarUnfoldable/sidebarUnfoldableSlice'
import {
  selectSidebarShow,
  setValue as updateSidebarShow,
} from '../redux/features/sidebarShow/sidebarShowSlice'
import { useAppDispatch, useAppSelector } from '../redux/hooks'
import { selectActiveBusinessEntity } from '../redux/features/activeBusinessEntity/activeBusinessEntitySlice'
import { _print_model_data } from '../utils/general'

const AppSidebar = ({ showLogo = false }) => {
  const dispatch = useAppDispatch()
  const unfoldable = useAppSelector(selectSidebarUnfoldable)
  const sidebarShow = useAppSelector(selectSidebarShow)
  const activeBusinessEntity = useAppSelector(selectActiveBusinessEntity)

  return (
    <CSidebar
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch(updateSidebarShow(visible))
      }}
    >
      {/*showLogo && (
        <CSidebarBrand className="d-none d-md-flex" to="/">
          <img className="sidebar-brand-full" src={brandFull} alt={'ERP Solution'} />
          <img
            className="sidebar-brand-narrow"
            src={brandNarrow}
            style={{ width: '2rem' }}
            alt={'ERP Solution'}
          />
        </CSidebarBrand>
      )*/}
      <CSidebarNav>
        <SimpleBar>
          <AppSidebarNav items={navigation} />
        </SimpleBar>
      </CSidebarNav>
      {activeBusinessEntity ? (
        <div className="sidebar-active-be">
          <CDropdownItem>
            {activeBusinessEntity.logo ? (
              <span className="pe-2">
                <CAvatar src={_print_model_data(activeBusinessEntity.logo.url)} size="md" />
              </span>
            ) : null}
            {activeBusinessEntity.title}
          </CDropdownItem>
        </div>
      ) : null}
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch(updateSidebarUnfoldable(!unfoldable))}
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
